import Vue from 'vue';
import OpenServicesErrorsComponent from '@bizpal/open-services-errors-component';
import OpenServicesFooterComponent from '@bizpal/open-services-footer-component';
import interaction from '@bizpal/open-services-interaction-mixins';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import algoliasearch from 'algoliasearch/lite';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faMinusSquare, faPlusSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import 'buefy/dist/buefy.css';
import { Icon, ConfigProgrammatic } from 'buefy';
import VueI18nSgc from 'vue-i18n';

//
Vue.component("open-services-errors-component", OpenServicesErrorsComponent);
Vue.component("open-services-footer-component", OpenServicesFooterComponent); // icons
library.add(faMinusSquare, faPlusSquare);
Vue.component("font-awesome-icon", FontAwesomeIcon); // buefy
Vue.use(Icon);
ConfigProgrammatic.setOptions({
  defaultIconComponent: "vue-fontawesome",
  defaultIconPack: "fas"
}); // language
Vue.use(VueI18nSgc); // Create VueI18n instance with options

const i18n = new VueI18nSgc({
  locale: "en"
});
var script = {
  name: 'OpenServicesSgcLookup',
  // vue component name
  i18n: {
    locale: "en",
    messages: {
      en: {
        no_option: "Sorry, no matching options for ",
        placeholder: "Type to search",
        placeholder_prov: "Please select",
        label_city: "Select a City | Select Cities",
        label_prov: "Select Province | Select Provinces",
        sgc: "SGC"
      },
      // end en
      fr: {
        no_option: "Désolé, aucunes options correspondantes pour ",
        placeholder: "Tapez pour rechercher",
        placeholder_prov: "Veuillez sélectionner",
        label_city: "Sélectionnez une ville | Sélectionnez les villes",
        label_prov: "Sélectionnez une province | Sélectionnez des provinces",
        sgc: "CGT"
      } // end fr

    } // end message

  },
  // end i18n
  props: {
    lang: {
      type: String,
      default: "en"
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: ""
    },
    province: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    hasSource: {
      type: Boolean,
      default: true
    },
    inputCode: {
      type: String,
      default: ""
    },
    showCode: {
      type: Boolean,
      default: true
    },
    visibility: {
      type: Boolean,
      default: true
    },
    placeholderText: {
      type: String,
      default: null
    }
  },
  // end props
  mixins: [interaction],
  data: function () {
    return {
      mylang: this.lang,
      myLabel: this.label,
      isMultiple: this.multiple,
      indexName: this.lang === "fr" ? "prod_sgc_2016_fr" : "prod_sgc_2016_en",
      provinceEn: [{
        name: "Newfoundland and Labrador",
        sgc: "10"
      }, {
        name: "Prince Edward Island",
        sgc: "11"
      }, {
        name: "Nova Scotia",
        sgc: "12"
      }, {
        name: "New Brunswick",
        sgc: "13"
      }, {
        name: "Quebec",
        sgc: "24"
      }, {
        name: "Ontario",
        sgc: "35"
      }, {
        name: "Manitoba",
        sgc: "46"
      }, {
        name: "Saskatchewan",
        sgc: "47"
      }, {
        name: "Alberta",
        sgc: "48"
      }, {
        name: "British Columbia",
        sgc: "59"
      }, {
        name: "Yukon",
        sgc: "60"
      }, {
        name: "Northwest Territories",
        sgc: "61"
      }, {
        name: "Nunavut",
        sgc: "62"
      }],
      provinceFr: [{
        name: "Terre-Neuve-et-Labrador",
        sgc: "10"
      }, {
        name: "Île-du-Prince-Édouard",
        sgc: "11"
      }, {
        name: "Nouvelle-Écosse",
        sgc: "12"
      }, {
        name: "Nouveau-Brunswick",
        sgc: "13"
      }, {
        name: "Québec",
        sgc: "24"
      }, {
        name: "Ontario",
        sgc: "35"
      }, {
        name: "Manitoba",
        sgc: "46"
      }, {
        name: "Saskatchewan",
        sgc: "47"
      }, {
        name: "Alberta",
        sgc: "48"
      }, {
        name: "Colombie-Britannique",
        sgc: "59"
      }, {
        name: "Yukon",
        sgc: "60"
      }, {
        name: "Territoires du Nord-Ouest",
        sgc: "61"
      }, {
        name: "Nunavut",
        sgc: "62"
      }],
      provinces: [],
      resetOnOptionsChange: false,
      options: [],
      selected: null,
      resultData: {},
      countLabel: 1,
      isShowing: false,
      error: null,
      interationProduct: "SGC Lookup - Widget",
      previousMulitpleSelection: []
    };
  },
  // end data
  components: {
    "v-select": vSelect
  },
  // end component
  mounted: function () {
    this.$i18n.locale = this.toggleLang;
    this.countLabel = this.isMultiple ? 2 : 1; // Note, have to use $tc instead of $t for language plural.

    this.myLabel = this.getLabel;
    this.provinces = this.lang === "fr" ? this.provinceFr : this.provinceEn; //algolia search

    var appid = "IQKSBFPSWC";
    var secret = "f8aab81f78e6415f1ea46a4c80c1eb20"; // eslint-disable-next-line
    this.client = algoliasearch(appid, secret);
    this.index = this.client.initIndex(this.indexName);

    if (this.toggleInputCode) {
      this.getName();
    }
  },
  // end mounted
  computed: {
    toggleSource: function () {
      return this.hasSource;
    },
    toggleProvince: function () {
      return this.province;
    },
    toggleMultiple: function () {
      return this.multiple;
    },
    toggleLang: function () {
      return this.lang == "fr" ? this.lang : "en";
    },
    toggleLabel: function () {
      return this.showLabel;
    },
    getLabel: function () {
      //here we return myLabel because
      // we need the translation
      return this.label !== "" ? this.label : this.province ? this.$tc("label_prov", this.countLabel) : this.$tc("label_city", this.countLabel);
    },
    // end getLabel
    toggleCode: function () {
      return this.showCode;
    },
    toggleInputCode: function () {
      return this.inputCode;
    },
    toggleVisibility: function () {
      return this.visibility ? "show" : "hide";
    },
    getPlaceholder: function () {
      return this.placeholderText;
    }
  },
  // end computed
  watch: {
    //props
    province: function () {
      this.myLabel = this.getLabel; //reset v-select data

      this.selected = null;
      this.options = [];

      if (this.province) {
        this.provinces = this.lang === "fr" ? this.provinceFr : this.provinceEn;
      } else {
        this.provinces = [];
      }
    },
    // end province
    label: function () {
      this.myLabel = this.toggleLabel;
    },
    // end label
    multiple: function () {
      this.countLabel = this.multiple ? 2 : 1;
      this.isMultiple = this.multiple ? this.multiple : false;
      this.myLabel = this.getLabel;
    },
    // end multiple
    lang: function () {
      this.$i18n.locale = this.lang;
      this.provinces = this.lang === "fr" ? this.provinceFr : this.provinceEn;
      this.indexName = this.lang === "fr" ? "prod_sgc_2016_fr" : "prod_sgc_2016_en", this.mylang = this.toggleLang;
      this.myLabel = this.getLabel; // reset v-select data

      this.options = [];
      this.selected = null;

      if (this.client) {
        this.index = this.client.initIndex(this.indexName);
      }

      if (this.inputCode) {
        this.getName();
      }
    },
    // end lang
    toggleInputCode: function () {
      if (this.inputCode) {
        this.getName();
      } else {
        this.selected = null;
      }
    },
    // end toggleInputCode
    selected: function (current) {
      if (current !== null) {
        this.resultData.sgc = [];

        if (this.isMultiple) {
          // to remove html code from title
          var tempArray = current.map(el => {
            return {
              code: el.sgc,
              name: this.decodeHTMLEntities(el.name)
            };
          });
          this.resultData.sgc = tempArray;
        } else {
          //not multiple
          this.resultData.sgc = new Array({
            code: current.sgc,
            name: this.decodeHTMLEntities(current.name)
          });
        }
      } else {
        // null
        this.resultData.sgc = [];
      }

      this.$emit("change", this.resultData);
    } // end selected

  },
  // end watch
  methods: {
    // eslint-disable-next-line
    onSearch: function (search, loading) {
      var self = this;

      if (search != "") {
        this.index.search(search, {
          hitsPerPage: 20,
          facets: "*"
        }).then(({
          hits,
          query
        }) => {
          // track interactions
          sessionStorage.setItem("userQuery", query); // track keyword not found

          if (hits.length == 0) {
            let propsKeyword = {};
            propsKeyword[self.mxKeywordNotFound.properties.keyword] = query;
            let propsInteraction = self.mxGetDefaultInteractionProp(self.toggleLang, this.interationProduct);
            let statement = self.mxCreateNodeStatement("k", self.mxKeywordNotFound.label, propsKeyword);
            let statementInteraction = self.mxCreateNodeStatement("n", self.mxInteraction.label, propsInteraction); // create Merge relationship Interaction and UserDate

            let statementRelationshipDate = this.mxCreateDateMergeRelationshipDate(propsInteraction.key, propsInteraction.timestamp_readable);
            let statementRelationshipKeyWordNotFound = self.mxCreateInteractionRelationshipStatement(self.mxInteraction.label, propsInteraction.key, self.mxKeywordNotFound.relationship, self.mxKeywordNotFound.label, self.mxKeywordNotFound.properties.timestamp, [propsKeyword.timestamp], false); //from mixin

            self.mxSaveInteraction(process.env.VUE_APP_NEO4J_URL, process.env.VUE_APP_NEO4J_USER, process.env.VUE_APP_NEO4J_PWD, [statement, statementInteraction, statementRelationshipKeyWordNotFound, statementRelationshipDate]);
          } // display search results in input


          self.options = [];

          for (var i = 0; i < hits.length; i++) {
            //obtain a keyword that matched
            var highlightKeywords = "";

            if (hits[i]._highlightResult.alternate_name != null) {
              var keywords = hits[i]._highlightResult.alternate_name.value;
              keywords = keywords.split(";");
              keywords.forEach(function (item) {
                if (item.indexOf("<em>") != -1) {
                  highlightKeywords += item;
                  highlightKeywords += ", ";
                }
              });
            }

            if (highlightKeywords.length > 0 && highlightKeywords.substring(highlightKeywords.length - 2, highlightKeywords.length) == ", ") {
              highlightKeywords = highlightKeywords.substring(0, highlightKeywords.length - 2);
            } //display info


            self.options.push({
              name: hits[i]._highlightResult.name.value,
              sgc: hits[i].sgc,
              alternate_name: highlightKeywords
            });
          }
        }).catch(err => {
          // eslint-disable-next-line
          console.log(err);
          self.error = err;
          return;
        });
      }
    },
    // end onSearch
    getName: function () {
      if (this.province) {
        for (var i = 0; i < this.provinces.length; i++) {
          if (this.toggleInputCode === this.provinces[i].sgc) {
            if (this.isMultiple) {
              this.selected = [{
                name: this.provinces[i].name,
                sgc: this.provinces[i].sgc
              }];
            } else {
              this.selected = {
                name: this.provinces[i].name,
                sgc: this.provinces[i].sgc
              };
            }

            break; // exit the for loop
          } else {
            this.selected = null;
          }
        }

        this.emitEvent(this.selected);
      } else {
        // only search string
        this.index.search(this.toggleInputCode, {
          facetFilters: ["sgc:" + this.toggleInputCode] // to search using sgc attribute

        }).then(({
          hits
        }) => {
          if (hits.length == 0) {
            this.selected = null;
            return;
          }

          if (this.isMultiple) {
            this.selected = [{
              name: hits[0].name,
              sgc: hits[0].sgc
            }];
          } else {
            this.selected = {
              name: hits[0].name,
              sgc: hits[0].sgc
            };
          }

          this.emitEvent(this.selected);
        }).catch(err => {
          this.error = err;
        });
      }
    },
    //end getName
    decodeHTMLEntities: function (str) {
      var element = document.createElement("div");

      if (str && typeof str === "string") {
        // strip script/html tags
        str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, "");
        str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, "");
        element.innerHTML = str;
        str = element.textContent;
        element.textContent = "";
      }

      return str;
    },
    //end decodeHTMLEntities
    emitEvent: function (current) {
      if (current !== null) {
        if (this.isMultiple) {
          // to remove html code from title
          var tempArray = current.map(el => {
            return {
              code: el.sgc,
              name: this.decodeHTMLEntities(el.name)
            };
          });
          this.resultData.sgc = tempArray;
          if (this.resultData.sgc.length == 0) this.options = []; // to clear data
        } else {
          //not multiple
          this.resultData.sgc = new Array({
            code: current.sgc,
            name: this.decodeHTMLEntities(current.name)
          });
        }
      } else {
        // null
        this.resultData.sgc = [];
        this.options = []; // to clear data
      } //this.$emit("change", this.resultData);
      // save interaction


      if (this.resultData.sgc.length > 0 && this.previousMulitpleSelection.length < this.resultData.sgc.length) {
        this.previousMulitpleSelection = this.resultData.sgc;
        let propsKeyword = {};
        let sgcObj = this.resultData.sgc.pop(); // eslint-disable-next-line prettier/prettier

        let myKeyword = this.toggleProvince ? "from pull down option for Province" : sessionStorage.getItem("userQuery");
        propsKeyword[this.mxKeywordFound.properties.keyword] = myKeyword;
        propsKeyword[this.mxKeywordFound.properties.code] = sgcObj.code;
        propsKeyword[this.mxKeywordFound.properties.code_name] = sgcObj.name;
        let propsInteraction = this.mxGetDefaultInteractionProp(this.locale, this.interationProduct);
        let KeywordStatement = this.mxCreateNodeStatement("k", this.mxKeywordFound.label, propsKeyword);
        let statementInteraction = this.mxCreateNodeStatement("n", this.mxInteraction.label, propsInteraction); // create Merge relationship Interaction and UserDate

        let statementRelationshipDate = this.mxCreateDateMergeRelationshipDate(propsInteraction.key, propsInteraction.timestamp_readable);
        let statementRelationshipKeyWordFound = this.mxCreateInteractionRelationshipStatement(this.mxInteraction.label, propsInteraction.key, this.mxKeywordFound.relationship, this.mxKeywordFound.label, this.mxKeywordFound.properties.timestamp, [propsKeyword.timestamp], false); //from mixin

        this.mxSaveInteraction(process.env.VUE_APP_NEO4J_URL, process.env.VUE_APP_NEO4J_USER, process.env.VUE_APP_NEO4J_PWD, [KeywordStatement, statementInteraction, statementRelationshipKeyWordFound, statementRelationshipDate]);
      } else {
        this.previousMulitpleSelection = [];
      } // else length > 0

    } // emitEvent

  } // end methods

}; // end export default

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "sgc-lookup",
    class: _vm.toggleVisibility
  }, [_vm.error ? _c('div', {
    staticClass: "error"
  }, [_c('open-services-errors-component', {
    attrs: {
      "lang": _vm.toggleLang
    },
    on: {
      "closed": function ($event) {
        _vm.error = null;
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.toggleLabel ? _c('div', {
    staticClass: "field-label is-normal has-text-left"
  }, [_c('label', {
    staticClass: "has-text-left"
  }, [_vm._v(_vm._s(_vm.getLabel))])]) : _vm._e(), _vm._v(" "), _vm.toggleProvince ? _c('div', [_c('v-select', {
    ref: "provLookup",
    attrs: {
      "label": "name",
      "multiple": _vm.toggleMultiple,
      "options": _vm.provinces,
      "placeholder": _vm.getPlaceholder != null ? _vm.getPlaceholder : _vm.$t('placeholder_prov')
    },
    on: {
      "input": _vm.emitEvent
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function (option) {
        return [_c('span', {
          domProps: {
            "innerHTML": _vm._s(option.name)
          }
        }), _vm.toggleCode ? _c('span', [_vm._v("  "), _c('span', {
          staticClass: "small"
        }, [_vm._v("[" + _vm._s(_vm.$t("sgc")) + "\n            "), _c('span', {
          staticClass: "small",
          domProps: {
            "innerHTML": _vm._s(option.sgc)
          }
        }), _vm._v("]")])]) : _vm._e()];
      }
    }, {
      key: "selected-option",
      fn: function (optionSelected) {
        return [_c('p', [_c('span', {
          domProps: {
            "innerHTML": _vm._s(optionSelected.name)
          }
        }), _vm.toggleCode ? _c('span', [_vm._v("  "), _c('span', {
          staticClass: "small"
        }, [_vm._v("[" + _vm._s(_vm.$t("sgc")) + "\n              "), _c('span', {
          staticClass: "small",
          domProps: {
            "innerHTML": _vm._s(optionSelected.sgc)
          }
        }), _vm._v("]")])]) : _vm._e()])];
      }
    }], null, false, 3649617315),
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  })], 1) : _c('div', [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('v-select', {
    ref: "sgcLookup",
    attrs: {
      "label": "name",
      "multiple": _vm.toggleMultiple,
      "options": _vm.options,
      "placeholder": _vm.getPlaceholder != null ? _vm.getPlaceholder : _vm.$t('placeholder'),
      "filterable": false,
      "select-on-key-codes": [27, 13],
      "reset-on-options-change": _vm.resetOnOptionsChange
    },
    on: {
      "search": _vm.onSearch,
      "input": _vm.emitEvent
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function (option) {
        return [_c('span', {
          staticClass: "titleBigger",
          domProps: {
            "innerHTML": _vm._s(option.name)
          }
        }), _vm.toggleCode ? _c('span', [_vm._v("  "), _c('span', {
          staticClass: "small"
        }, [_vm._v("[" + _vm._s(_vm.$t("sgc")) + "\n                "), _c('span', {
          staticClass: "small",
          domProps: {
            "innerHTML": _vm._s(option.sgc)
          }
        }), _vm._v("]")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
          staticClass: "sgc-lookup-result-keywords",
          domProps: {
            "innerHTML": _vm._s(option.alternate_name)
          }
        })];
      }
    }, {
      key: "selected-option",
      fn: function (optionSelected) {
        return [_c('p', [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.decodeHTMLEntities(optionSelected.name))
          }
        }), _vm.toggleCode ? _c('span', [_vm._v("  "), _c('span', {
          staticClass: "small"
        }, [_vm._v("[" + _vm._s(_vm.$t("sgc")) + "\n                  "), _c('span', {
          staticClass: "small",
          domProps: {
            "innerHTML": _vm._s(optionSelected.sgc)
          }
        }), _vm._v("]")])]) : _vm._e()])];
      }
    }, {
      key: "no-options",
      fn: function (ref) {
        var search = ref.search;
        var searching = ref.searching;
        return [searching ? [_c('div', {
          attrs: {
            "role": "alert",
            "aria-live": "assertive"
          }
        }, [_c('p', [_vm._v("\n                  " + _vm._s(_vm.$t("no_option")) + " "), _c('em', [_vm._v(_vm._s(search))])])])] : _c('em', {
          staticStyle: {
            "opacity": "0.8"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.getPlaceholder != null ? _vm.getPlaceholder : _vm.$t("placeholder")) + "\n            ")])];
      }
    }]),
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }), _vm._v(" "), !_vm.province && _vm.toggleSource ? _c('div', {
    staticClass: "inlineRight"
  }, [_c('a', {
    attrs: {
      "tabindex": "0"
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        _vm.isShowing ^= true;
      },
      "click": function ($event) {
        _vm.isShowing ^= true;
      }
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": _vm.isShowing ? 'minus-square' : 'plus-square',
      "size": "is-small",
      "pack": "fas",
      "type": "is-info"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" Source")])], 1)]) : _vm._e(), _vm._v(" "), _vm.isShowing ? _c('div', [_c('open-services-footer-component', {
    attrs: {
      "lang": _vm.toggleLang,
      "widget": "sgc"
    }
  })], 1) : _vm._e()], 1)])])]);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-1165fe6f_0", {
    source: ".sgc-lookup .v-select{width:100%}.sgc-lookup div.dropdown.v-select.single.unsearchable{width:100%}.sgc-lookup div.dropdown-toggle{width:100%}.sgc-lookup .v-select .input[type=search].form-control,.sgc-lookup .vs__selected-options .input[type=search]{width:100%}.sgc-lookup .vs__search .input[type=search]{width:100%}.sgc-lookup .vs__selected-options{width:100%}.sgc-lookup .vs__dropdown-option{border:1px solid #e0e0e0;border-left-width:10px;border-bottom-left-radius:4px;border-bottom-right-radius:4px;padding:5px 4px;background:#fff;font-family:Arial,Helvetica,sans-serif}.sgc-lookup .vs__dropdown-option--highlight,.sgc-lookup .vs__dropdown-option:active,.sgc-lookup .vs__dropdown-option:focus,.sgc-lookup .vs__dropdown-option:hover{background-color:#ddd;color:#000;padding:5px 4px;border-left-width:10px;border-left-color:#66afe9}.sgc-lookup .vs__dropdown-menu{cursor:pointer}.sgc-lookup .sgc-lookup-result-keywords{color:grey;font-size:small}.sgc-lookup .sgc-lookup-result-keywords em{color:#000;font-weight:700;background-color:transparent}.sgc-lookup .titleBigger{font-size:medium}.sgc-lookup .titleBigger em{color:#000;font-weight:700;background-color:transparent}.sgc-lookup .inlineRight{float:right;margin-right:8px}.show{display:block}.hide{display:none}.sgc-lookup .small{font-size:small}.sgc-lookup div.inlineRight a,.sgc-lookup div.inlineRight a:focus{outline:0;color:#00f}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__ = undefined;
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

// Import vue component

const install = function installOpenServicesSgcLookup(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('OpenServicesSgcLookup', __vue_component__);
}; // Create module definition for Vue.use()
// to be registered via Vue.use() as well as Vue.component()


__vue_component__.install = install; // Export component by default
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

export default __vue_component__;
